export default {
  payment: {},
  payments: []
}
